/* global I18n */

import VideoTimestamps from "../video_timestamps"
import VideoControls from "../video_controls"
import React, {useState} from "react"

function VideoOptions({
  vimeoId,
  iframe,
  timestamps,
  transcript,
  canWatchFullVideo,
  showContentTabs
}) {
  const [openTab, setOpenTab] = useState(
    (timestamps && "highlights") || (transcript && "transcript")
  )
  if (!iframe) return null

  return (
    <div className="embedded-video--options">
      <div className="video-controls">
        <VideoControls
          iframe={iframe}
          vimeoId={vimeoId}
        />
      </div>
      {showContentTabs && (
        <>
          <VideoOptionsTabs
            timestamps={timestamps}
            transcript={transcript}
            openTab={openTab}
            setOpenTab={setOpenTab}
          />
          {openTab === "highlights" &&
            <div className="video-timestamps">
              <VideoTimestamps
                iframe={iframe}
                timestamps={timestamps}
                canWatchVideo={canWatchFullVideo}
              />
            </div>}
        </>
      )}
      {showContentTabs && openTab === "transcript" &&
        <div
          className="embedded-video__transcript"
          dangerouslySetInnerHTML={{__html: transcript}}
        />}
    </div>
  )
}

function VideoOptionsTabs({timestamps, transcript, openTab, setOpenTab}) {
  if (!timestamps && !transcript) return null

  return (
    <div className="embedded-video__tabs">
      {!!timestamps &&
        <a
          className={openTab === "highlights" ? "active" : undefined}
          onClick={() => setOpenTab("highlights")}>
          {I18n.t("js.embedded_video.highlights")}
        </a>}
      {timestamps && transcript ? " | " : undefined}
      {!!transcript &&
        <a
          className={openTab === "transcript" ? "active" : undefined}
          onClick={() => setOpenTab("transcript")}>
          {I18n.t("js.embedded_video.transcript")}
        </a>}
    </div>
  )
}

export default VideoOptions
